import { useAppContext } from '../Services/AppContext';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';

export default function FormattedDate({ date }) {
	const { translation } = useAppContext();

	const [dateFormat, setDateFormat] = useState('dd.MM.yyyy');
	useEffect(() => {
		setDateFormat(translation['base.dateFormatJsReact'] || 'dd.MM.yyyy');
	}, [translation]);

	return <>{format(new Date(date), dateFormat)}</>;
}

export function FormattedDateTime({ datetime }) {
	const { translation } = useAppContext();

	const [dateFormat, setDateFormat] = useState('dd.MM.yyyy, HH:mm');
	useEffect(() => {
		setDateFormat(
			(translation['base.dateFormatJsReact'] || 'dd.MM.yyyy') + ', HH:mm',
		);
	}, [translation]);

	return <>{format(new Date(datetime), dateFormat)}</>;
}

export function FormattedNcziTime({ datetime }) {
	const { translation } = useAppContext();

	return <>{format(new Date(datetime), 'HH:mm')}</>;
}

export function FormattedDateTimeWithSeconds({ datetime }) {
	const { translation } = useAppContext();

	const [dateFormat, setDateFormat] = useState('dd.MM.yyyy, HH:mm:ss');
	useEffect(() => {
		setDateFormat(
			(translation['base.dateFormatJsReact'] || 'dd.MM.yyyy') + ', HH:mm:ss',
		);
	}, [translation]);

	return <>{format(new Date(datetime), dateFormat)}</>;
}
